/**
 * Presentation for the merchandising console's in-app notification types (hrm's notification.constant,
 * cut to what merchandising-service raises).
 *
 * `notif_type` is a free varchar in public.notifications on purpose — a new producer can raise
 * a new type without a back-end release. These maps only decorate the known ones; anything
 * unrecognised falls back to DEFAULT_NOTIF_* so an unmapped type still renders correctly.
 */

/**
 * merchandising-service raises nothing yet. The confirmed-order notice (Phase 2) and the approval
 * requests (Phase 3, `<DOC>_REQUEST` / `<DOC>_DECISION` per approval doc type) are added here
 * with the phase that raises them: a new notif_type must be in these maps.
 */
export const NOTIF_TYPE_LABEL: {[key: string]: string} = {}

/** `_REQUEST` is amber because it means "someone is waiting on you". */
export const NOTIF_TYPE_TONE: {[key: string]: string} = {}

export const NOTIF_TYPE_ICON: {[key: string]: string} = {}

export const DEFAULT_NOTIF_TONE = 'secondary'
export const DEFAULT_NOTIF_ICON = 'notifications'

export const NOTIF_TYPE_OPTIONS = Object.keys(NOTIF_TYPE_LABEL).map((id) => ({
  id,
  title: NOTIF_TYPE_LABEL[id],
}))

export const notifTone = (notifType?: string) =>
  NOTIF_TYPE_TONE[notifType || ''] || DEFAULT_NOTIF_TONE
export const notifIcon = (notifType?: string) =>
  NOTIF_TYPE_ICON[notifType || ''] || DEFAULT_NOTIF_ICON
export const notifLabel = (notifType?: string) =>
  NOTIF_TYPE_LABEL[notifType || ''] || notifType || '—'
